'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  height: ', ';\n  max-width: ', ';\n  width: 100%;\n'], ['\n  height: ', ';\n  max-width: ', ';\n  width: 100%;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledFrame = _styledComponents2.default.iframe(_templateObject, function (props) {
  return props.height ? props.height + 'px' : '100%';
}, function (props) {
  return props.maxWidth ? props.maxWidth + 'px' : '100%';
});

var EmbeddedFrame = function EmbeddedFrame(_ref) {
  var title = _ref.title,
      src = _ref.src,
      height = _ref.height,
      width = _ref.width;
  return _react2.default.createElement(StyledFrame, {
    title: title,
    src: src,
    height: height,
    maxWidth: width
  });
};

EmbeddedFrame.propTypes = {
  /** title of the embedded frame */
  title: _propTypes2.default.string.isRequired,
  /** URL of the embedded frame */
  src: _propTypes2.default.string.isRequired,
  /** height of the embedded frame */
  height: _propTypes2.default.string,
  /** max width of the embedded frame */
  width: _propTypes2.default.string
};

EmbeddedFrame.defaultProps = {
  height: window.innerHeight,
  width: window.innerWidth
};

EmbeddedFrame.displayName = 'EmbeddedFrame';

exports.default = EmbeddedFrame;
EmbeddedFrame.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'EmbeddedFrame',
  'props': {
    'height': {
      'defaultValue': {
        'value': 'window.innerHeight',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height of the embedded frame'
    },
    'width': {
      'defaultValue': {
        'value': 'window.innerWidth',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'max width of the embedded frame'
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'title of the embedded frame'
    },
    'src': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'URL of the embedded frame'
    }
  }
};